"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = require("@cian/peperrors/shared");
var uri_1 = require("./uri");
var WebSocketClient = /** @class */ (function () {
    function WebSocketClient(params) {
        var _this = this;
        this.onOpen = function (event) {
            _this.runHandlers('open', event);
        };
        this.onClose = function (event) {
            _this.runHandlers('close', event);
        };
        this.onMessage = function (event) {
            _this.runHandlers('message', event);
        };
        this.onError = function (error) {
            _this.runHandlers('error', error);
        };
        this.uri = uri_1.normalizeURI(params.uri);
        this.eventHandlersMap = new Map();
        this.clearInternalMap();
    }
    WebSocketClient.prototype.open = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.socket) {
                            switch (this.socket.readyState) {
                                case this.socket.CONNECTING:
                                    return [2 /*return*/, this.connection];
                                case this.socket.OPEN:
                                case this.socket.CLOSING:
                                    return [2 /*return*/];
                            }
                        }
                        this.socket = new WebSocket(this.uri.toString());
                        this.connection = new Promise(function (resolve, reject) {
                            var onOpen;
                            var onClose;
                            onOpen = function () {
                                _this.removerInternalListener('close', onClose);
                                _this.removerInternalListener('open', onOpen);
                                resolve();
                            };
                            onClose = function (error) {
                                _this.removerInternalListener('close', onClose);
                                _this.removerInternalListener('open', onOpen);
                                reject(new shared_1.ConfigurationError({
                                    message: "Couldn't open socket connection, code: " + error.code,
                                    domain: 'chats-api#WebSocketClient#open()',
                                    details: {
                                        code: error.code,
                                        reason: error.reason,
                                    },
                                }));
                            };
                            _this.addInternalListener('open', onOpen);
                            _this.addInternalListener('close', onClose);
                            _this.socket.onopen = _this.onOpen;
                            _this.socket.onclose = _this.onClose;
                            _this.socket.onmessage = _this.onMessage;
                            _this.socket.onerror = _this.onError;
                        });
                        return [4 /*yield*/, this.connection];
                    case 1:
                        _a.sent();
                        this.connection = null;
                        return [2 /*return*/];
                }
            });
        });
    };
    WebSocketClient.prototype.close = function (code, reason) {
        if (this.socket && this.isSocketClosed()) {
            return true;
        }
        this.socket.close(code, reason);
        return this.isSocketClosed();
    };
    WebSocketClient.prototype.send = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.socket || this.isSocketClosed()) {
                            throw new shared_1.ConfigurationError({
                                message: 'Socket connection not open',
                                domain: 'chats-api#WebSocketClient#send()',
                            });
                        }
                        if (!(this.socket.readyState === this.socket.CONNECTING)) return [3 /*break*/, 3];
                        if (!this.connection) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.connection];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2: return [2 /*return*/, new Promise(function (resolve, reject) {
                            if (_this.isSocketClosed()) {
                                reject(new shared_1.ConfigurationError({
                                    message: 'Socket connection not open',
                                    domain: 'chats-api#WebSocketClient#send()',
                                }));
                                return;
                            }
                            resolve(_this.send(data));
                        })];
                    case 3: return [2 /*return*/, this.socket.send(JSON.stringify(data))];
                }
            });
        });
    };
    WebSocketClient.prototype.addEventListener = function (event, handler) {
        var identifier = event + "-" + Date.now();
        var arrayHandlers = this.eventHandlersMap.get(event) || [];
        arrayHandlers.push({ identifier: identifier, handler: handler });
        this.eventHandlersMap.set(event, arrayHandlers);
        return identifier;
    };
    WebSocketClient.prototype.removeEventListener = function (event, identifier) {
        var arrayHandlers = this.eventHandlersMap.get(event);
        if (!arrayHandlers || !arrayHandlers.length) {
            return;
        }
        var handler = typeof identifier === 'function' ? identifier : null;
        var filtredArrayHandlers = arrayHandlers.filter(function (item) {
            return handler ? item.handler !== handler : item.identifier !== identifier;
        });
        this.eventHandlersMap.set(event, filtredArrayHandlers);
        return;
    };
    WebSocketClient.prototype.isSocketClosed = function () {
        return this.socket && [this.socket.CLOSING, this.socket.CLOSED].includes(this.socket.readyState);
    };
    WebSocketClient.prototype.addInternalListener = function (event, handler) {
        var arr = this.internalEventHandlersMap.get(event);
        arr.push(handler);
        this.internalEventHandlersMap.set(event, arr);
    };
    WebSocketClient.prototype.removerInternalListener = function (event, handler) {
        var arr = this.internalEventHandlersMap.get(event);
        this.internalEventHandlersMap.set(event, arr.filter(function (h) { return h !== handler; }));
    };
    WebSocketClient.prototype.clearInternalMap = function () {
        this.internalEventHandlersMap = new Map([
            ['close', []],
            ['error', []],
            ['message', []],
            ['open', []],
        ]);
    };
    WebSocketClient.prototype.runHandlers = function (type, event) {
        var internalHandlersArr = this.internalEventHandlersMap.get(type);
        internalHandlersArr.forEach(function (handler) { return handler(event); });
        var publishHandlers = this.eventHandlersMap.get(type);
        if (publishHandlers && publishHandlers.length) {
            publishHandlers.forEach(function (_a) {
                var handler = _a.handler;
                return handler(event);
            });
        }
    };
    return WebSocketClient;
}());
exports.WebSocketClient = WebSocketClient;
//# sourceMappingURL=index.js.map